import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  DomSanitizer,
  SafeHtml
} from '@angular/platform-browser';

import sprite from 'icons/workshop.sprite.svg';

import { IconSizeModel }  from './typings/icon.size';
import { IconThemeModel } from './typings/icon.theme';

@Component({
  selector   : 'wor-icon',
  styles: [ require('./icon.component.scss') ],
  template: require('./icon.component.html')
})
export class IconComponent implements OnChanges {
  public sprite: string = sprite;

  @Input() icon  : string | SafeHtml;
  @Input() theme : IconThemeModel = 'workshop';
  @Input() size  : IconSizeModel  = 'md';

  constructor (
    private sanitizer : DomSanitizer
  ) {}

  ngOnChanges ( changes: SimpleChanges ) : void {
    if (changes.icon) {
      this._updateIcon();
    }
  }

  private _updateIcon () : void {
    if (this.icon && this.isTheme('inline')) {
      this.icon = this.sanitizer.bypassSecurityTrustHtml(this.icon as string);
    }
  }

  isExtraLargeIcon () : boolean {
    return this.size === 'x-lg';
  }

  isLargeIcon () : boolean {
    return this.size === 'lg';
  }

  isSmallIcon () : boolean {
    return this.size === 'sm';
  }

  isTheme ( theme : IconThemeModel = 'workshop' ) : boolean {
    return theme === this.theme;
  }
}
